import { ContractAnnexLine, ContractAnnexLineJson } from '@gi/models/contract-annex-line';
import { ContractAnnexModel } from '@gi/models/contract-annex-model';
import { ContractOffer, ContractOfferJson } from '@gi/models/contract-offer';
import { HttpHelper } from '@helpers/http.helper';

export interface ContractAnnexJson {
  id: number;
  label: string;
  contract_annex_lines: Partial<ContractAnnexLineJson>[];
  contract_offer: Partial<ContractOfferJson>;
}

export class ContractAnnex {
  constructor(
    public id?: number,
    public label?: string,
    public lines?: ContractAnnexLine[],
    public offer?: ContractOffer
  ) {}

  static fromJson(json: Partial<ContractAnnexJson>): ContractAnnex {
    return new ContractAnnex(
      json.id,
      json.label,
      json.contract_annex_lines
        ? json.contract_annex_lines.map((lineJson: Partial<ContractAnnexLineJson>) =>
            ContractAnnexLine.fromJson(lineJson)
          )
        : [],
      json.contract_offer ? ContractOffer.fromJson(json.contract_offer) : null
    );
  }

  static toJson(model: ContractAnnex): ContractAnnexJson {
    return {
      id: model.id ? HttpHelper.toJsonProperty(model.id) : undefined,
      label: HttpHelper.toJsonProperty(model.label),
      contract_annex_lines: model.lines?.length
        ? model.lines.map((line: ContractAnnexLine) => ContractAnnexLine.toJson(line))
        : [],
      contract_offer: model.offer ? ContractOffer.toJson(model.offer) : null
    };
  }

  static fromContractAnnexModel(model: ContractAnnexModel): ContractAnnex {
    const contractAnnex: ContractAnnex = new ContractAnnex();
    contractAnnex.label = model.label;
    contractAnnex.lines = model.contractAnnexModelLines.map(
      (line: ContractAnnexLine) =>
        new ContractAnnexLine(null, line.type, line.label, line.chargeChoice, line.discountPercentage)
    );
    return contractAnnex;
  }
}
